/**
 * Progress indicators only accept values in the range 0 - 100. This function helps with transforming value to the scale of 0 - 100.
 * @param {number} value Current value
 * @param {number} min Minimum expected value
 * @param {number} max Maxmimum expected value
 * @returns {number} Value in scale of 0 - 100. Warning: returned value could be outside of 0 - 100 range depending if `value` is outside of `min` and `max` range. Progress indicator will always default the display to `0%` or `100%`. If you're dividing by `0`, then returned value is corrected to `0`.
 */
export const normalizeProgressValue = (value: number, min: number, max: number): number => {
    const division = ((value - min) * 100) / (max - min);
    return Number.isFinite(division) ? division : 0;
};

/**
 * Progress indicators only accept values in the range 0 - 100. This function will normalize the progress value using `normalizeProgressValue`.
 * @param {number} value Current value
 * @param {number} min Minimum expected value
 * @param {number} max Maxmimum expected value
 * @returns {number} Value in scale of 0 - 100. Warning: if the normalized value is outside of 0 - 100 range, then the value is corrected to the nearest range bound.
 */
export const getProgressPercentage = (value: number, min: number, max: number): number => {
    const progress: number = normalizeProgressValue(value, min, max);

    if (progress > 100) {
        return 100;
    }

    if (progress < 0) {
        return 0;
    }

    return progress;
};
